module.exports = __webpack_public_path__ + "img/Poster_605ConferenceSpace.c15c0f98.png";